<template>
  <el-input-localized-numeric
    v-model="price"
    :disabled="disabled"
    size="small"
    @change="onPurchaseUnitPriceChange"
  >
    <template slot="append">
      {{ currency }}
    </template>
  </el-input-localized-numeric>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    currency: {
      type: String,
      default() {
        return 'HUF';
      },
      required: false,
    },
    purchaseUnitPrice: {
      type: Number,
      default() {
        return 0;
      },
      required: false,
    },
    minPurchaseUnitPrice: {
      type: Number,
      default() {
        return 0;
      },
      required: false,
    },
  },
  data() {
    return {
      price: 0,
    };
  },
  watch: {
    purchaseUnitPrice(price) {
      this.price = price;
    },
  },
  mounted() {
    this.price = this.purchaseUnitPrice;
  },
  methods: {
    onPurchaseUnitPriceChange(price) {
      this.$emit('change', parseFloat(price));
    },
  },
};
</script>
